export const REPORTS_HANDLE_MODAL_REPORT_TYPE = "REPORTS_HANDLE_MODAL_REPORT_TYPE";
export const REPORTS_HANDLE_MODAL_SELECT_TYPE = "REPORTS_HANDLE_MODAL_SELECT_TYPE";
export const REPORTS_HANDLE_MODAL_SELECT_REPORT = "REPORTS_HANDLE_MODAL_SELECT_REPORT";

